@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.ridepromocodes
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.models.RidePromoCodeStatus

object RedeemRidePromoCodeEndpoint :
    EndPoint<RedeemRidePromoCodeEndpoint.Request, RedeemRidePromoCodeEndpoint.Response>() {
    class Request(
        val passengerId: KmmLong,
        val promoCode: String
    )

    class Response(
        @Suppress("NON_EXPORTABLE_TYPE") val status: DtoName<RidePromoCodeStatus>,
        val amount: Double? = null
    )
}